"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mui_1 = require("tss-react/mui");
const FlagField_1 = __importDefault(require("components/QuickenControls/FlagField"));
const styles_1 = require("../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const UserFlag = ({ attributes, callbacks, editable, fieldActive, txn, showIcons, focusField, }) => {
    const { classes } = useStyles();
    return (<styles_1.RegListItem {...attributes} tabIndex={null} onClick={null} className={classes.iconButtonColumn}>
      <FlagField_1.default classes={{ iconRoot: classes.iconButtonColumn }} value={txn.userFlag} autoFocus={fieldActive} inputRef={fieldActive ? (input) => {
            focusField.current = input; // eslint-disable-line
        } : null} editable={editable} onChange={(e) => { var _a; return (_a = callbacks.handleMenu) === null || _a === void 0 ? void 0 : _a.call(callbacks, 'userFlag', txn, e.target.value); }} show={(txn.userFlag && txn.userFlag !== 'NONE') || editable || showIcons}/>
    </styles_1.RegListItem>);
};
exports.default = UserFlag;
